import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const FirstPage = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 22 20">
      <path d="M0.744,0.045c0.403,0 0.73,0.32 0.745,0.719l0,18.484c0,0.412 -0.333,0.747 -0.745,0.747c-0.402,0 -0.73,-0.32 -0.744,-0.72l0,-18.482c0,-0.413 0.333,-0.747 0.744,-0.747l0,-0.001Zm17.157,0.319c1.04,-0.671 2.425,-0.374 3.093,0.665c0.233,0.361 0.356,0.783 0.355,1.214l-0.033,15.45c-0.002,1.236 -1.007,2.24 -2.243,2.24c-0.413,0 -0.818,-0.114 -1.17,-0.33l-12.257,-7.52c-1.052,-0.645 -1.38,-2.023 -0.731,-3.077c0.175,-0.286 0.413,-0.529 0.695,-0.711l12.291,-7.931Zm1.822,1.452c-0.228,-0.328 -0.677,-0.417 -1.016,-0.199l-12.29,7.931c-0.094,0.061 -0.173,0.142 -0.232,0.237c-0.216,0.352 -0.107,0.811 0.244,1.026l12.257,7.52c0.118,0.072 0.252,0.11 0.39,0.11c0.412,0 0.747,-0.335 0.748,-0.747l0.033,-15.45c0,-0.144 -0.04,-0.285 -0.118,-0.405l-0.016,-0.023Z" />
    </svg>
  );
};

FirstPage.defaultProps = {
  width: '100%',
  height: '100%',
};

export default FirstPage;
